module.exports = __webpack_public_path__ + "static/media/left.cf68dc68.svg";